<button
  class="button button-md"
  [class.button--primary]="variant() === 'primary'"
  [class.button--secondary]="variant() === 'secondary'"
  [class.button--tertiary]="variant() === 'tertiary'"
  [class.button--large]="size() === 'large'"
  [class.button--medium]="size() === 'medium'"
  [class.button--small]="size() === 'small'"
  [class.button--loading]="loading()"
  [type]="type()"
  [disabled]="disabled() || loading()"
  [attr.aria-disabled]="disabled() || loading() ? true : null"
  [attr.aria-busy]="loading() ? true : null"
  [attr.tabindex]="tabindex()"
>
  @if (loading()) {
    <span class="button__spinner"></span>
  }
  <span class="button__label" [class.button__label--hidden]="loading()">
    <ng-content />
  </span>
</button>
